import Toasters from './Toasters.container';

export default Toasters;
